import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useMetaTags } from '@/hooks/useMetaTags';
import { useAlbumContext } from '@/contexts/AlbumProvider';
import * as Sentry from "@sentry/react";

const NotFound = () => {
  const location = useLocation();
  const { albumSlug } = useAlbumContext()

  useMetaTags({
    title: '404 - Página no encontrada',
    pathname: '/404'
  });

  useEffect(() => {
    Sentry.captureMessage(
      `404 Error: Oops! Page not found: ${location.pathname}`,
      "error"
    );
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Acá no hay nada</p>
        <a href={`/${albumSlug}`} className="text-blue-500 hover:text-blue-700 underline">
          Volver al inicio
        </a>
      </div>
    </div>
  );
};

export default NotFound;
